module.exports = __webpack_public_path__ + "static/media/Aki.c9dabfcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueBridge/Aki.png
// module id = 3514
// module chunks = 0